// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"9f97a506","486":"4c0a084b","592":"7e91ab26"}[chunkId] + ".chunk.js";
};